import '../App.css';
import HeaderBar from '../HeaderObject.js';
import FooterBar from '../FooterObject.js';
import Banner from '../banner.js';
import CodeBlock from '../CodeBlock.js';
import DetailsWindow from '../DetailWindow.js';

import GameEmbed from '../GameEmbed.js';

import { Fade } from 'react-reveal';

export default function RolluPage(){
    return(
        <div className='App'>
            <HeaderBar />
            <Banner 
                title={"Rollu"}
                textCol={"#49477d"}
                height={"450px"}
                image={"https://safebuckledev.github.io/img/banner_ballG.png"}
            />

            <Fade bottom distance="40%" duration={750}>
            </Fade>

            <article>
                <GameEmbed 
                    projTitle={"Rollu"}
                    embedLink={"https://safebuckledev.github.io/ball_build/index.html"}
                    gameWidth={"960"}
                    gameHeight={"505"}
                    cropHeight={"5"}
                />
            </article>

            <article>
                <Fade bottom distance="40%" duration={750}>
                    <h1 className='TitleText'>Player Movement</h1>
                </Fade>

                <section>
                    <DetailsWindow 
                        details={"The player moves by applying force based on their input, creating a realistic feeling of the ball rolling. When the player stops giving input, the ball still rolls a bit, which adds a challenge. Players must constantly adjust their controls to keep the ball on the track and prevent it from falling off.\n\nThis movement system makes the game more exciting and urgent. Players need to make quick decisions to steer the ball effectively, which adds to the chaotic feel of the game. Overall, this design encourages players to improve their timing and reflexes as they face different challenges."}
                        image={"https://safebuckledev.github.io/img/ballproj/gif1.gif"}
                    />

                    <Fade bottom distance="40%" duration={750}>
                        <CodeBlock 
                            data={"public void Move(float verticalTilt, float horizontalTilt, Vector3 right)\n{\n    // Only apply movement when the player is grounded\n    if (OnGround())\n    {\n        CalculateFloorNormal();\n            \n        // No input from player\n        if (horizontalTilt == 0.0f && verticalTilt == 0.0f && rigidBody.velocity.magnitude > 0.0f)\n        {\n            rigidBody.velocity = Vector3.Lerp(rigidBody.velocity, Vector3.zero, moveForce * 0.1f * Time.deltaTime); // Slow down\n        }\n        else\n        {\n            Vector3 forward = Vector3.Cross(right, floorNormal);\n            Vector3 forwardForce = (verticalTilt > 0.0f ? 1.0f : 0.5f) * moveForce * verticalTilt * forward;\n            Vector3 rightForce = moveForce * horizontalTilt * right;\n            \n            Vector3 forceVector = forwardForce + rightForce;\n            \n            rigidBody.AddForce(forceVector);\n        }\n    }\n}"}
                        />
                    </Fade>
                </section>
            </article>

            <article>
                <Fade bottom distance="40%" duration={750}>
                    <h1 className='TitleText'>Camera Movement</h1>
                </Fade>

                <section>
                    <DetailsWindow 
                        details={"The camera rotates using quaternions, and the angle of rotation is determined by the maximum rotation combined with the player's horizontal and vertical input. This setup allows for smooth and fluid camera movement, ensuring that players can easily track their surroundings. By adjusting the camera angle in response to player input, it helps them see clearly where they need to go, especially when navigating downhill slopes. This feature enhances gameplay by providing better visibility and control, allowing the player to not make any mistakes when going down slopes."}
                        image={"https://safebuckledev.github.io/img/ballproj/gif2.gif"}
                    />

                    <Fade bottom distance="40%" duration={750}>
                        <CodeBlock 
                            data={"void CameraTilt()\n    {\n        float scaledVerticalTilt = initialXRotation - (verticalTilt * maxVerticalAngle);\n                        \n        float angleBetweenFloorNormal = useCameraAngleCorrection ? Vector3.SignedAngle(Vector3.up, player.floorNormal, transform.right) : 0.0f;\n                        \n        Quaternion targetXRotation = Quaternion.Euler(scaledVerticalTilt + angleBetweenFloorNormal, transform.rotation.eulerAngles.y, transform.rotation.eulerAngles.z);\n        transform.rotation = Quaternion.RotateTowards(transform.rotation, targetXRotation, tiltSpeed * Time.deltaTime);\n                        \n        float scaledHorizontalTilt = Input.GetAxis('Horizontal') * maxHorizontalAngle;\n                        \n        Quaternion targetZRotation = Quaternion.Euler(mCamera.rotation.eulerAngles.x, mCamera.rotation.eulerAngles.y, scaledHorizontalTilt);\n        mCamera.rotation = Quaternion.RotateTowards(mCamera.rotation, targetZRotation, tiltSpeed * Time.deltaTime);\n    }"}
                        />
                    </Fade>

                    <Fade bottom distance="40%" duration={750}>
                        <CodeBlock 
                            data={"void FollowTarget()\n{\n    Vector3 vectorA = new Vector3(transform.forward.x, 0.0f, transform.forward.z);\n\n    Vector3 vectorB = new Vector3(player.rigidBody.velocity.x, 0.0f, player.rigidBody.velocity.z);\n\n    float rotateAngle = Vector3.SignedAngle(vectorA.normalized, vectorB.normalized, Vector3.up);\n\n    float speedFactor = Vector3.Dot(vectorA, vectorB) > 0.0f ? vectorB.magnitude : 1.0f;\n\n    transform.Rotate(Vector3.up, rotateAngle * Mathf.Clamp(speedFactor, 1.0f, 2.0f) * Time.deltaTime);\n\n    transform.position = player.transform.position - (transform.forward * offset);\n    transform.LookAt(player.transform.position);\n}"}
                        />
                    </Fade>
                </section>
            </article>

            <FooterBar />
        </div>
    );
}